import cookie from 'js-cookie';

function getDefaultLocale() {
  let cookieLocale = cookie.get("origamCurrentLocale");
  let defaultLang = 'de-CH';
  if (!cookieLocale) {
    let userLang = navigator.language || navigator.userLanguage;
    userLang = userLang.toLowerCase().substring(0, 2);
    if (userLang === 'de') defaultLang = 'de-CH';
    else if (userLang === 'en') defaultLang = 'en-US';
    else if (userLang === 'fr') defaultLang = 'fr-CH';
    else if (userLang === 'cs') defaultLang = 'cs-CZ';
  } else {
    const cookieValue = cookieLocale.split('|')[0]; 
    defaultLang = cookieValue.split('c=')[1];
  }
  return defaultLang || 'de-CH';
}

function localeCookieValue(langCode) {
  return `c=${langCode}|uic=${langCode}`;
}

export function setDefaultLocale() {
  setCookies(getDefaultLocale());
}

export function setCookies(langCode) {
  cookie.set('origamLanguage', langCode, { expires: 365, path: '/' });
  cookie.set('origamCurrentLocale', localeCookieValue(langCode), { expires: 365, path: '/' });
}

export function setLanguage(langCode) {
  setCookies(langCode);
  window.location.reload();
}


// WEBPACK FOOTER //
// ./src/translate/actions.js